


























































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { VFields } from '@/models/v-fields';
import { ShippingAddress } from '@/models/filebunker/shippingaddress';
import { DealShipment } from '@/models/filebunker/dealshipment';
import { VHeaders, PaginationModel } from '@/models/pagedlistmodel';
import { Base } from '@/components/common/base';
import {getShipmentDealHeaders } from '@/views/fileBunker/deal/deal';
import { shipmentService,shippingAddressService,attachmentService } from '@/shared';

@Component({
    props: ['methodName', 'progress'],
    computed: {
        methodtoCall: {
            get() {
                return this.$props.methodName;
            },
        },
    },
    components: {
        Grid: () => import('@/components/common/app.grid.vue'),
        // ShippingAddress: () => import('../shippingaddress/add.vue'),
        ShippingAddress: () => import('@/views/admin/shippingaddress/add.vue'),

    },

})
export default class DealShipmentPage extends Base {
    public dealHeaders: VHeaders[] = getShipmentDealHeaders(this);
    public panel: any = 0; // [true, false];
    public dealIds: string = '';
    public shipment: any = {
        fromAddress: '',
        toAddress: '',
        description: '',
        packagingType: this.$parent.$t('dealShipment.lblValueFEDEX_ENVELOPE') as string,
        serviceType: '',
        weight: '',
    };
    public form: any = {};
    public dealShipment: DealShipment = {};
    public serviceTypes?: any[] = [
        {
            text: this.$parent.$t('dealShipment.lblFEDEX_2_DAY') as string,
            value: 'FEDEX_2_DAY',
        },
        {
            text: this.$parent.$t('dealShipment.lblPRIORITY_OVERNIGHT') as string,
            value: 'PRIORITY_OVERNIGHT',
        },
    ];
    public toAddresses?: ShippingAddress[] = [];
    public loading: boolean = false;
    public requestProgress: boolean = false;
    public formFields: Array<VFields<any>> = [];
    public storeId: number = 0;
    public actions: any[] = [];
    public pagedDeals: any[] = [];
    public pagination = new PaginationModel('created', true);
    public addressDialog: boolean = false;

    public beforeDestroy() {
        const buttons = [];
        this.$emit('updateToolBar', buttons);
    }
    public callMethod(methodName): void {
        if (methodName === 'backToList') {
            this.backToList();
        }
        if (methodName === 'create') {
            if (this.form.$valid) {
                this.create();
            } else {
                this.showAlert(false, this.$t('dealShipment.alertRequiredFields'));
                this.$emit('resetMethodName', methodName);
                return;
            }
        }
        if (methodName === 'openAddressDialog') {
            this.openAddressDialog();
        }
        if (methodName !== '') {
            this.$emit('resetMethodName', methodName);
        }
    }
    public updateToolBar(): void {
        const buttons: any = [];
        buttons.push({id: '0', type: 'button', title: this.$t('dealShipment.btnBack'), disabled: false, visible: true, class: 'btn', label: this.$t('dealShipment.btnBack'), click: 'backToList', icon: 'fas fa-arrow-left', requestProgress: true });
        
        buttons.push({id: 2, type: 'button', title: this.$t('dealShipment.btnAddAddress'), disabled: false, visible: true, class: 'btn', label: this.$t('dealShipment.btnAddAddress'), click: 'openAddressDialog', icon: 'fas fa-plus-circle', requestProgress: true });
        this.$emit('updateToolBar', buttons);
    }
    public async mounted(): Promise<void> {
        // toolbar
        this.updateToolBar();
        this.$watch('methodtoCall', (newVal, oldVal) => {
            if (newVal) {
                this.callMethod(newVal);
            }
        });
        this.setFields();
        this.storeId = this.userSession.storeId;
        this.dealIds = this.$route.query.id as string;
        if (this.dealIds) {
            this.getShippingAddresses();
            this.getDeals();
        }
    }

    public setFields(): void {
        this.formFields = [
            {
                key: 'fromAddress',
                type: 'v-alynk-text-field',
                required: true,
                templateOptions: {
                    counter: 50,
                    label: this.$parent.$t('dealShipment.formFields.fromAddress') as string,
                    required: true,
                    disabled: true,
                    loading: false,
                    rules:[
                        v => this.required('From Address',v)
                    ]
                },
            },
            {
                key: 'toAddress',
                type: 'v-alynk-select',
                required: true,
                templateOptions: {
                    label: this.$parent.$t('dealShipment.formFields.toAddress') as string,
                    required: true,
                    disabled: false,
                    items: this.toAddresses,
                    text: 'name',
                    value: 'id',
                    altag: this.$parent.$t('dealShipment.formFields.toAddress') as string,
                    loading: false,
                    rules:[
                        v => this.required('To Address',v)
                    ]
                },
            },
            {
                key: 'packagingType',
                type: 'v-alynk-text-field',
                required: true,
                templateOptions: {
                    counter: 50,
                    label: this.$parent.$t('dealShipment.formFields.packagingType') as string,
                    required: true,
                    disabled: true,
                    loading: false,
                    rules:[
                        v => this.required('Packaging Type',v)
                    ]
                },
            },
            {
                key: 'serviceType',
                type: 'v-alynk-select',
                required: true,
                templateOptions: {
                    label: this.$parent.$t('dealShipment.formFields.serviceType') as string,
                    required: true,
                    disabled: false,
                    items: this.serviceTypes,
                    text: 'text',
                    value: 'value',
                    altag: this.$parent.$t('dealShipment.formFields.serviceType') as string,
                    loading: false,
                    rules:[
                        v => this.required('Service Type',v)
                    ]
                },
            },
            {
                key: 'weight',
                type: 'v-alynk-text-field',
                required: true,
                templateOptions: {
                    counter: 8,
                    label: this.$parent.$t('dealShipment.formFields.weight') as string,
                    required: true,
                    disabled: false,
                    loading: false,
                    rules:[
                        v => this.required('Weight ((in lbs), should not be greator than 1 lb)',v)
                    ]
                },
            },
            {
                key: 'description',
                type: 'v-alynk-text-field',
                required: false,
                templateOptions: {
                    counter: 255,
                    label: this.$parent.$t('dealShipment.formFields.description') as string,
                    validations: '',
                    required: false,
                    disabled: false,
                    loading: false,
                },
            },
        ];
    }

    public async getShippingAddresses(): Promise<void> {
        try {
            this.formlyShowSkeleton(this.formFields, 'toAddress');
            const shippingAddress = await shippingAddressService.getAddresses();
            this.toAddresses = shippingAddress.results;
            if (this.toAddresses.length > 0) {
                this.setSelectItems('toAddress', this.toAddresses);
            }
        } finally {
            this.formlyHideSkeleton(this.formFields, 'toAddress');
        }
    }
    public async getDeals(): Promise<void> {
        try {
            this.loading = true;
            this.formlyShowSkeleton(this.formFields);
            const deals = await shipmentService.getAllDeals(this.dealIds);
            this.dealShipment = deals;
            this.pagedDeals = this.dealShipment.deals || [];
            this.pagination.totalItems = this.pagedDeals.length;
            this.shipment.fromAddress = this.dealShipment.fromAddress;
            this.shipment.description = this.dealShipment.description;
        } finally {
            this.loading = false;
            this.formlyHideSkeleton(this.formFields);
        }
    }

    public backToList() {
        if (history.state && history.length > 1) {
            this.$router.back();
        } else {
            this.$router.push({ name: 'app.deals' });
        }
    }

    public updatePaging(paging: any) {
        this.pagination = paging;
    }

    public setSelectItems(key, items) {
        const field = this.formFields.find((m) => {
            return m.key === key;
        });
        if (field) {
            field.templateOptions.items = items;
        }
    }
    
    public validateShipment(): Vue & { validate: () => boolean } {
        return this.$refs.shipmentForm as Vue & { validate: () => boolean };
    }
    
    public async create(): Promise<void> {
        if(this.validateShipment().validate()){
            if (!this.shipment.toAddress) {
                // this.showAlert(false, this.$t('dealShipment.alertToAddress'));
                return;
            }
            try {
                this.requestProgress = true;
                this.$emit('update:progress', this.requestProgress);
                this.shipment.dealIds = this.dealIds;
                const shipment = await shipmentService.saveShipment(this.shipment);
                if (shipment.id !== '') {
                    await attachmentService.viewAttachmentAsync(shipment.id);
                    this.showAlert(true, this.$t('dealShipment.alertShipmentSuccess'));
                    this.$router.push({ name: 'app.deals' });
                } else {
                    this.showAlert(false, this.$t('dealShipment.alertShipmentError'));
                }
            } finally {
                this.requestProgress = false;
                this.$emit('update:progress', this.requestProgress);
            }
        }
    }

    public openAddressDialog() {
        this.addressDialog = true;
    }

    public closeDialog(val: boolean): void {
        this.addressDialog = val;
        this.getShippingAddresses();
    }
}
